import If from 'Views/Components/If/If';
import moment from 'moment/moment';
import RiskScoreBox from 'Views/Components/Intel/RiskScoreBox';
import { AlaresReport, AlaresReportUtil } from 'Models/Interfaces/AlaresReport';
import { CustomerEntity } from 'Models/Entities';
import { insolvencyRiskToTooltip } from 'Models/Enums/MappedEnumDefinitions';

const AdverseAlertsBusinessSummary = (props: {
	customer: CustomerEntity,
	alaresReport: AlaresReport,
	lastUpdated?: Date
}) => {

	const { customer, alaresReport, lastUpdated } = props;
	const caseFormerNames = AlaresReportUtil.getCaseFormerNames(alaresReport);
	const caseNames = AlaresReportUtil.getCaseNames(alaresReport);

	return (
		<div className="section business-summary">
			<div className="business-details">
				<h5>Business details</h5>
				<div className="fields">
					<p className="field"><b>Name:</b> {caseNames}</p>
					<p className="field"><b>Former names:</b> {caseFormerNames}</p>
					<p className="field"><b>ABN:</b> {customer.abn}</p>
					<If condition={!!customer.acn}>
						<p className="field"><b>ACN:</b> {customer.acn}</p>
					</If>
					<If condition={!!customer.trusteeACN}>
						<p className="field"><b>Trustee ACN:</b> {customer.trusteeACN}</p>
					</If>
					<p className="field">
						<b>Last updated:</b> {lastUpdated ? moment(lastUpdated).format('Do MMMM YYYY') : '-'}
					</p>
				</div>
			</div>
			<div className="insolvency-risk">
				<h5>Insolvency Risk Rating</h5>
				<RiskScoreBox score={customer.newestAlares?.insolvencyRiskRating} />
				<p className="insolvency-risk-tooltip">
					{insolvencyRiskToTooltip[customer.newestAlares?.insolvencyRiskRating]}
				</p>
			</div>
		</div>
	);
};

export default AdverseAlertsBusinessSummary;
